
// import { Timestamp } from 'firebase/firestore';

// export const getTimestampNow = () => Timestamp.now();

export const daysOfWeek = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
